import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';

export const Loading = () => {
  const header = (
    <>
      <div className="mt-20 h-[50px] w-full animate-pulse rounded-md bg-gray-300 md:w-[600px]"></div>
      <div className="mt-2 h-[30px] w-full animate-pulse rounded-md bg-gray-300 md:w-[800px]"></div>
    </>
  );

  const title = <div className="mt-2 h-[30px] w-[200px] animate-pulse rounded-md bg-gray-300"></div>;
  const divider = <div className="my-10 h-[10px] w-full animate-pulse rounded-md bg-gray-300"></div>;

  const dailyBubble = (
    <div className="flex flex-col gap-4 md:flex-row">
      <div className="mt-4 h-[150px] w-full animate-pulse rounded-md bg-gray-300"></div>
      <div className="mt-4 h-[150px] w-full animate-pulse rounded-md bg-gray-300"></div>
      <div className="mt-4 h-[150px] w-full animate-pulse rounded-md bg-gray-300"></div>
      <div className="mt-4 h-[150px] w-full animate-pulse rounded-md bg-gray-300"></div>
    </div>
  );

  const cards = (
    <div className="flex flex-col gap-4 md:flex-row">
      <div className="mt-4 h-[400px] w-full animate-pulse rounded-md bg-gray-300"></div>
      <div className="mt-4 h-[400px] w-full animate-pulse rounded-md bg-gray-300"></div>
      <div className="mt-4 h-[400px] w-full animate-pulse rounded-md bg-gray-300"></div>
    </div>
  );
  return (
    <Container className="min-h-40">
      <SubContainer>
        {header}
        {divider}
        {title}
        {dailyBubble}
        {divider}
        {title}
        {cards}
        {divider}
        {title}
        {cards}
        {divider}
        {title}
        {cards}
        {divider}
        {title}
        {cards}
      </SubContainer>
    </Container>
  );
};
